import React from "react";
import { Helmet } from "react-helmet";

function Head(props) {
  const isStaging =
    typeof window !== "undefined" &&
    (window.location.href.includes(
      "https://staging-tekrevol.tekstagearea.com"
    ) ||
      window.location.href.includes("http://localhost:8000"));

  return (
    <Helmet>
      <link rel="canonical" href={props?.pageurl} />
      <link rel="alternate" hreflang={props?.lang} href={props?.pageurl} />
      <link rel="alternate" href={props?.pageurl} hreflang="x-default" />
      <meta name="msvalidate.01" content="2E5E301254F9DEB0B72E800F335D24FC" />
      {isStaging && <meta name="robots" content="noindex, nofollow" />}
   
    </Helmet>
  );
}

export default Head;
